import { render, staticRenderFns } from "./LeadAllocationLog.vue?vue&type=template&id=0309cced&"
import script from "./LeadAllocationLog.vue?vue&type=script&lang=js&"
export * from "./LeadAllocationLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports